<template>
  <section class="form-list">
    <el-form
      ref="form"
      class="form"
      :rules="rules"
      :model="teacher"
      label-position="left"
      label-width="160px"
    >
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="teacher.nickname" maxlength="16"/>
      </el-form-item>
      <v-image-upload
        v-model="teacher.avatar"
        :isEdit="true"
        label="头像"
        prefix="teacher"
        ratio="1:1"
        propName="avatar"
      />
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="teacher.phone" min="0" type="number" placeholder="请输入老师的手机号"/>
      </el-form-item>
      <el-form-item label="不在小程序列表展示">
        <el-switch v-model="teacher.is_hide_in_list" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后，小程序的首页老师列表、筛选列表均不展示"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>
      <el-form-item label="企业微信号">
        <el-input v-model="teacher.we_chat"/>
      </el-form-item>
      <el-form-item label="微博号">
        <el-input v-model="teacher.micro_blog" />
      </el-form-item>
      <el-form-item label="美拍号">
        <el-input v-model="teacher.mei_pai" />
      </el-form-item>

      <el-form-item label="个人简介">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入老师的个人简介"
          v-model="teacher.brief"
          maxlength="1000"
          show-word-limit
        />
      </el-form-item>

<!--      <el-form-item
        label="2021作品收录个数"
        prop="video_count"
      >
        <v-input-number
          placeholder="请输入2021年作品收录个数"
          v-model="teacher.video_count"
        />
      </el-form-item>

      <el-form-item
        label="2021作品总播放量"
        prop="view_count"
      >
        <v-input-number
          placeholder="请输入2021年作品总播放量"
          v-model="teacher.view_count"
        />
      </el-form-item>

      <el-form-item label="2021最受欢迎作品名称" prop="video_name">
        <el-input v-model="teacher.video_name" maxlength="255" placeholder="请输入2021年最受欢迎作品名称" />
      </el-form-item>

      <el-form-item label="2021参加过的活动名称" prop="dynamic_name">
        <el-input v-model="teacher.dynamic_name" maxlength="255" placeholder="请输入2021年参加过的活动名称" />
      </el-form-item>

      <el-form-item label="2021学生祝福语">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入2021年学生想对老师说的祝福语"
          v-model="teacher.blessing"
          maxlength="2000"
          show-word-limit
        />
      </el-form-item>-->

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即保存</el-button>
        <el-button @click="RouteConfig.teacherList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from "@/router/config";
import { show, update } from '@/api/teacher';
import { index } from '@/api/store';

export default {
  name: RouteConfig.teacherEdit.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    teacher: {
      nickname: '',
      phone: '',
      we_chat: '',
      micro_blog: '',
      mei_pai: '',
      avatar: '',
      brief: '',
      is_hide_in_list: 0,

      video_count: 0,
      view_count: 0,
      video_name: '',
      dynamic_name: '',
      blessing: '',
    },
    stores: [],
    rules: {
      nickname: [{ required: true, message: '请输入老师昵称', trigger: 'change' }],
      avatar: [{ required: true, message: '请上传老师头像', trigger: 'change' }],
      phone: [{ required: true, message: '请输入老师手机号', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  methods: {
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;
      this.teacher = data;
    },
    async getStores() {
      const { isError, data } = await index({ is_only_name: 1 });
      if (isError) return;
      this.stores = data;
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const postData = { ...this.teacher };

        this.isSaving = true;
        const { isError } = await update(this.id, postData);
        this.isSaving = false;
        if (isError) return;

        RouteConfig.teacherList.back();
      });
    },
  },
  beforeMount() {
    this.getStores();
    this.show();
  },
};
</script>
